import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-medium tracking-widest uppercase text-accent-600 bg-accent-100 px-3 py-1 rounded-full">
            热门话题
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mt-4">
            热门话题
          </h2>
          <p className="text-sm text-foreground-600 mt-2">当前最火热的话题都在这里了</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3">
            {topicsData.map((item, i) => (
              <div
                key={i}
                className="group cursor-pointer bg-background-100 border border-background-200/70 rounded-full px-5 py-3 flex items-center gap-3 hover:border-primary-300 hover:bg-primary-50 transition-all duration-200"
              >
                <span className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  #{item.name}
                </span>
                <span className="text-xs text-foreground-500 bg-background-200/70 px-2 py-0.5 rounded-full whitespace-nowrap">
                  {item.count}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}